import { CalendarRange } from '@/Calendar/type';

const isInRange = (day: Date, range?:CalendarRange) => {
  if (!range?.[0] || !range?.[1]) return false;
  return day >= range[0] && day < range[1];
};

export default isInRange;
